import { ENV } from './env';

// Helper function to generate CDN URL
export const getCDNUrl = (path) => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  return `${ENV.PIC_BASE_URL}/${cleanPath}`;
};

// Specific CDN URLs for different asset types
export const CDN_URLS = {
  // Logo assets
  logo: getCDNUrl('static/logo.png'),
  logoFull: getCDNUrl('static/memu-logo.png'),
  banner: getCDNUrl('static/memu-banner.png'),

  // Avatar images
  avatar: [
    getCDNUrl('static/avatar/avatar_1.png'),
    getCDNUrl('static/avatar/avatar_2.png'),
    getCDNUrl('static/avatar/avatar_3.png'),
    getCDNUrl('static/avatar/avatar_4.png'),
    getCDNUrl('static/avatar/avatar_5.png'),
    getCDNUrl('static/avatar/avatar_6.png'),
    getCDNUrl('static/avatar/avatar_7.png'),
    getCDNUrl('static/avatar/avatar_8.png'),
    getCDNUrl('static/avatar/avatar_9.png'),
    getCDNUrl('static/avatar/avatar_10.png'),
    getCDNUrl('static/avatar/avatar_11.png'),
    getCDNUrl('static/avatar/avatar_12.png'),
    getCDNUrl('static/avatar/avatar_13.png'),
    getCDNUrl('static/avatar/avatar_14.png'),
    getCDNUrl('static/avatar/avatar_15.png'),
  ],

  // Blog images
  blog: {
    blog1: getCDNUrl('static/blog/blog_1.png'),
    blog2: getCDNUrl('static/blog/blog_2.png'),
  },
  
  // Cursor assets
  cursor: getCDNUrl('static/cursor-small.png'),
  
  // Feature images
  feature1: getCDNUrl('static/feature/1.png'),
  feature2: getCDNUrl('static/feature/2.png'),
  feature3: getCDNUrl('static/feature/3.png'),
  
  // Benchmark
  benchmark: getCDNUrl('static/benchmark.png'),
  
  // Use case images
  usecase: {
    aiCompanion: getCDNUrl('static/usecase/ai_companion-0000.jpg'),
    aiRobot: getCDNUrl('static/usecase/ai_robot-0000.jpg'),
    aiIP: getCDNUrl('static/usecase/ai_ip-0000.png'),
    aiRolePlay: getCDNUrl('static/usecase/ai_role_play-0000.jpg'),
    aiEdu: getCDNUrl('static/usecase/ai_edu-0000.jpg'),
    aiTherapy: getCDNUrl('static/usecase/ai_therapy-0000.jpg'),
    aiCreation: getCDNUrl('static/usecase/ai_creation-0000.jpg')
  },
  
  // Integration logos
  integrate: {
    openai: getCDNUrl('static/integrate/openai.png'),
    anthropic: getCDNUrl('static/integrate/anthropic.png'),
    gemini: getCDNUrl('static/integrate/genmini.png'),
    deepseek: getCDNUrl('static/integrate/deepseek.png'),
    qwen: getCDNUrl('static/integrate/qwen.png'),
    langgraph: getCDNUrl('static/integrate/langgraph.png'),
    crewai: getCDNUrl('static/integrate/crewai.png'),
    sillytavern: getCDNUrl('static/integrate/sillytavern.png'),
    n8n: getCDNUrl('static/integrate/n8n.png'),
    dify: getCDNUrl('static/integrate/dify.png')
  },
  
  // Showcase images
  showcase: {
    showcase1: getCDNUrl('static/showcase/showcase1.png'),
    showcase2: getCDNUrl('static/showcase/showcase2.png'),
    showcase3: getCDNUrl('static/showcase/showcase3.png'),
    showcase4: getCDNUrl('static/showcase/showcase4.png'),
    showcase5: getCDNUrl('static/showcase/showcase5.png')
  },

  workflow: getCDNUrl('static/workflow.png'),
};

export default CDN_URLS;